<template>
  <div class="space-y-2">
    <BaseFormLabel> Media </BaseFormLabel>
    <div class="p-4 bg-gray-100 rounded shadow-inner">
      <MediaList :acc-product-template-id="accProductTemplateId" />
    </div>
    <!-- <FileUpload
      :options="{
        allowMultiple: true,
        acceptedFileTypes,
      }"
      v-model="formData.media"
    /> -->
    <!-- <BaseButton
      v-if="formData.media.length"
      type="button"
      primary
      :disabled="loading"
      class="w-full"
      @click="storeMedia"
    >
      Save
    </BaseButton> -->
  </div>
</template>

<script>
// import { accProductTemplateMediaClient } from '@/api/clients/admin';
// import FileUpload from 'Components/FileUpload/Index.vue';
import MediaList from './MediaList.vue';

export default {
  components: {
    // FileUpload,
    MediaList,
  },
  // inject: ['refreshAccProductTemplate'],
  props: {
    accProductTemplateId: {
      type: String,
      required: true,
    },
  },
  // data() {
  //   return {
  //     loading: false,
  //     formData: {
  //       media: [],
  //     },
  //     acceptedFileTypes: [
  //       'image/*',
  //     ],
  //   };
  // },
  // methods: {
  //   async storeMedia() {
  //     try {
  //       this.loading = true;

  //       await accProductTemplateMediaClient.store(this.accProductTemplateId, this.formData);

  //       this.formData.media = [];

  //       await this.refreshAccProductTemplate();

  //       this.loading = false;
  //     } catch (error) {
  //       //
  //     } finally {
  //       this.loading = false;
  //     }
  //   },
  // },
};
</script>
